<template>
  <header class="" id="header-main">
    <nav class="navbar navbar-main navbar-expand-lg shadow-sm navbar-light bg-white p-0" id="navbar-main">
      <div class="w-100">
        <button v-on:click="toggleMenu()" class="navbar-toggler order-lg-2 p-2 w-100" type="button" data-toggle="collapse"
                data-target="#navbar-main-collapse" aria-controls="navbar-main-collapse" aria-expanded="false"
                aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div :class="{show: menuIsOpen}" class="collapse navbar-collapse navbar-collapse-overlay order-lg-3  " style="top: 3rem; bottom: 1rem" id="navbar-main-collapse">
          <div class="position-relative float-end" style="display: none">
            <button class="navbar-toggler m-2" v-on:click="menuIsOpen = false"  type="button" data-toggle="collapse" data-target="#navbar-main-collapse"
                    aria-controls="navbar-main-collapse" aria-expanded="false" aria-label="Toggle navigation">
              <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none"
                   stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                   class="feather feather-x">
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
              </svg>
            </button>
          </div>
          <ul class="navbar-nav ms-3  overflow-auto pe-3">
            <li class="nav-item nav-item-spaced d-lg-block text-nowrap  border-end pe-3 me-3">
              <div class="d-flex h-100 align-items-center">
                <a href="/" class="text-capitalize nav-link p-0 active">
                  <img :alt="appName" :src="logoSrc" style="height: 30px" class="">
                  <span v-if="appName && !hasWordmarkLogo" class="ms-2">{{ appName }}</span>
                </a>
              </div>
            </li>
            <li v-if="currentStore" class="nav-item nav-item-spaced d-lg-block text-nowrap border-end pe-3 me-3">
              <span style="color: #191919;" class="nav-link text-capitalize-first">
                 {{ currentStore.name }} ({{currentStore.currency}})
              </span>
            </li>
            <li v-for="item in filterMenuItems(menu)" :key="item.route" class="nav-item nav-item-spaced d-lg-block text-nowrap">
              <router-link v-if="item.route !== 'back'"
                v-on:click="menuIsOpen = false"
                class="nav-link text-capitalize-first"
                :class="{active: isActive(item.route)}"
                :active-class="''"
                :exact-active-class="''"
                :to="{name: item.route, query: item.query}"
              >
                <span v-if="hasBadge(item)" class="position-relative">
                  {{ trans(`menu.items.${item.route}`) }}
                  <span class="position-absolute top-0 start-100 translate-middle p-1 bg-danger border border-light rounded-circle ms-1 mt-1"></span>
                </span>
                <span v-else>
                  {{ trans(`menu.items.${item.route}`) }}
                </span>

              </router-link>
              <a v-else
                           @click.prevent="menuIsOpen = false; $router.back()"
                           class="nav-link text-capitalize"
                           :class="{active: isActive(item.route)}"
                      href="#"
              >
                <i class="fa fa-arrow-left"></i> {{ trans(`menu.items.${item.route}`) }}
              </a>
            </li>
          </ul>
          <ul class="navbar-nav align-items-lg-center d-lg-flex ms-3 ms-lg-auto">
            <li v-if="this.isTrader && !this.getUser.pcId || this.isTraderOperator" class="nav-item mt-2 mb-2">
              <div class="d-flex flex-row align-items-center gap-2">
                <label for="traderStatus" class="badge" :class="{'bg-danger': !trader().isActive, 'bg-success': trader().isActive}">{{ trans('direction.in') }}</label>
                <div class="form-switch">
                  <input id="traderStatus" @click.prevent="showStatusConfirm(trader() ? !trader().isActive : false, Direction.PAY_IN)" class="form-check-input" style="cursor: pointer" type="checkbox" role="switch" :checked="trader() ? trader().isActive : false">
                </div>
              </div>
            </li>
            <li v-if="this.isTrader && !this.getUser.pcId || this.isTraderOperator" class="nav-item mt-2 mb-2 me-5">
              <div class="d-flex flex-row align-items-center gap-2">
                <label for="traderPayOutStatus" class="badge" :class="{'bg-danger': !trader().isPayOutActive, 'bg-success': trader().isPayOutActive}">{{ trans('direction.out') }}</label>
                <div class="form-switch">
                  <input id="traderPayOutStatus" @click.prevent="showStatusConfirm(trader() ? !trader().isPayOutActive : false, Direction.PAY_OUT)" class="form-check-input" style="cursor: pointer" type="checkbox" role="switch" :checked="trader() ? trader().isPayOutActive : false">
                </div>
              </div>
            </li>
            <ExportTasksIndicator v-if="showExportTasksIndicator"></ExportTasksIndicator>
            <li v-if="this.isOperator || this.isAdmin" class="nav-item">
              <div class="d-flex flex-row align-items-center">
                <label class="badge" :class="this.isAdmin ? 'bg-warning' : 'bg-primary' ">{{ trans(`labels.role.badge.${this.getRole}`) }}</label>
              </div>
            </li>
            <li class="nav-item">
              <a class="nav-link text-nowrap" href="#" @click.prevent="doLogout()">
                {{ trans('labels.logout') }} ({{ this.getUser ? this.getUser.email : '' }})
              </a>
            </li>
          </ul>
        </div>

      </div>
    </nav>
  </header>


  <b-modal
      :title="getStatusConfirmTitle()"
      :modelValue="statusConfirmModal"
      body-class="d-none"
      footer-class="border-top-0 d-flex justify-content-between"
      @update:modelValue="statusConfirmModal = $event"
  >
    <template #footer>
      <button
          type="button"
          @click="statusConfirmModal = false; statusConfirmData = { status: null, direction: null }"
          class="btn btn-outline-secondary btn-sm text-capitalize-first"
      >
        {{ trans('button.cancel') }}
      </button>
      <button
          type="button"
          @click="confirmStatusChange()"
          class="btn btn-outline-primary btn-sm text-capitalize-first"
      >
        {{ trans('button.confirm') }}
      </button>
    </template>
  </b-modal>
</template>

<style scoped>

@media (max-width: 991.98px) {
  .nav-link.active {
    background-color: initial;
  }
}


</style>

<script>
import {mapGetters} from 'vuex';
import {useRoute} from "vue-router";
import moment from "moment";
import {helper} from "@/service/CommonHelper";
import APIClient from "@/service/APIClient";
import {Direction} from "@/models/enum/Direction";
import {UserPermission} from "@/models/enum/UserPermission";
import {BModal} from "bootstrap-vue-3";
import ExportTasksIndicator from "@/components/ExportTasksIndicator.vue";

const api = new APIClient();

export default {
  components: {BModal, ExportTasksIndicator},
  data() {
    return {
      menuIsOpen: false,
      currentDate: moment(),
      currentDateUTC: moment().utc(),
      statusConfirmModal: false,
      statusConfirmData: {
        status: null,
        direction: null,
      },
    }
  },
  computed: {
    appName() {
      return this.$store.getters.getAppData?.app_name ?? process.env.VUE_APP_TYPE;
    },
    hasWordmarkLogo() {
      return process.env.VUE_APP_LOGO_EXT === 'svg';
    },
    logoSrc() {
      return this.hasWordmarkLogo ? '/logo.svg' : '/apple-touch-icon.png';
    },
    Direction() {
      return Direction
    },
    ...mapGetters([
      'getUser',
      'isTrader',
      'isTraderOperator',
      'isOperator',
      'isMerchant',
      'isMerchantOperator',
      'isAdmin',
      'isTeamLead',
      'isReferral',
      'getRole'
    ]),
    ...mapGetters({
      currentStore: 'merchantStores/getCurrent'
    }),
    showExportTasksIndicator() {
      return this.isAdmin || this.isOperator || this.isMerchant || this.isMerchantOperator
    },
    menu() {
      if (this.isTraderOperator) {
        return [
          { route: 'dashboard'},
          { route: 'statistic'},
          { route: 'accountOperations'},
          { route: 'deals'},
          { route: 'requisites'},
          { route: 'settings'},
        ]
      }

      if (this.isTrader) {
        if (this.isTrader && this.getUser.pcId) {
          return [
            { route: 'dashboard'},
            { route: 'statistic'},
            { route: 'accountOperations'},
            { route: 'deals'},
            { route: 'settings'},
          ]
        }

        return [
          { route: 'dashboard'},
          { route: 'statistic'},
          { route: 'accountOperations'},
          { route: 'deals'},
          { route: 'requisites'},
          { route: 'traderOperators'},
          { route: 'settings'},
        ]
      }

      if (this.isTeamLead) {
        return [
          { route: 'dashboard'},
          { route: 'statistic'},
          { route: 'accountOperations'},
          { route: 'deals'},
          { route: 'traders'},
          { route: 'requisites'},
          { route: 'settings'},
        ]
      }

      if (this.isOperator) {
        const menuItems = [
          { route: 'deals'},
          { route: 'traders'},
          { route: 'providers'},
          { route: 'requisites'},
          { route: 'devices'},
          { route: 'antiFraudAlerts'},
          ...(this.$store.getters.getAppData?.TELEGRAM_NOTIFICATION_CENTER_ENABLED ? [{ route: 'notificationCenter' }] : []),
          { route: 'transfers'},
          { route: 'currencies'},
          { route: 'statistic'},
          { route: 'settings'},
        ];

        if (!this.$store.getters.hasPermission(UserPermission.HIDE_ROUTING_SECTION)) {
          menuItems.splice(5, 0, { route: 'routing' });
        }

        if (this.$store.getters.hasPermission(UserPermission.HIDE_STATISTICS_SECTION)) {
          return menuItems.filter((item) => item.route !== 'statistic');
        }
        
        return menuItems;
      }


      if (this.isAdmin) {
        let currentStore = this.$store.getters['merchantStores/getCurrent']
        if (currentStore !== null) {
          return [
            { route: 'back'},
            { route: 'accountOperations', query: {storeId: currentStore.id} },
            { route: 'invoices', query: {storeId: currentStore.id} },
          ]
        }

        const menuItems = [
          { route: 'users' },
          { route: 'statistic' },
          { route: 'wallets' },
          { route: 'antiFraudAlerts' },
          ...(this.$store.getters.getAppData?.TELEGRAM_NOTIFICATION_CENTER_ENABLED ? [{ route: 'notificationCenter' }] : []),
          { route: 'routing' },
          { route: 'aggregator' },
          { route: 'transfers' },
          { route: 'currencies' },
          { route: 'deals' },
          { route: 'requisites' },
          { route: 'requisitesGroups' },
          { route: 'devices' },
          { route: 'settings' },
        ];

        if (this.$store.getters.hasPermission(UserPermission.EDIT_SETTINGS)
          || this.$store.getters.hasPermission(UserPermission.EDIT_SETTINGS_PAYMENT_PAGE)) {
          menuItems.push({ route: 'systemSettings' });
        }

        return menuItems;
      }

      if (this.isReferral) {
        return [
          { route: 'dashboard'},
          { route: 'statistic'},
          { route: 'accountOperations'},
          { route: 'deals'},
          { route: 'settings'},
        ]
      }

      if (this.isMerchant) {
        let currentStore = this.$store.getters['merchantStores/getCurrent']
        if (currentStore !== null) {
          return [
            { route: 'back'},
            { route: 'accountOperations', query: {storeId: currentStore.id} },
            { route: 'invoices', query: {storeId: currentStore.id} },
          ]
        }

        return [
          { route: 'dashboard' },
          { route: 'statistic'},
          { route: 'merchantOperators'},
          { route: 'settings'},
        ]
      }

      if (this.isMerchantOperator) {
        let currentStore = this.$store.getters['merchantStores/getCurrent']
        if (currentStore !== null) {
          return [
            { route: 'back'},
            { route: 'accountOperations', query: {storeId: currentStore.id} },
            { route: 'invoices', query: {storeId: currentStore.id} },
          ]
        }

        return [
          { route: 'dashboard' },
          { route: 'statistic'},
          { route: 'settings'},
        ]
      }

      return [];
    }
  },
  methods: {
    trader: function() {
      if (this.isTrader) {
        return this.getUser
      }

      if (this.isTraderOperator) {
        return this.getUser.trader
      }

      return null;
    },
    checkAfCount: async function () {
      if (this.isAdmin || this.isOperator) {
        setTimeout(async () => {
          this.$store.dispatch('afHasNew', await api.antiFraudAlertsCount(this.$store.getters['getAfLastId']))
          this.checkAfCount();
        }, 30000);
      }
    },
    getDate: function () {
        this.currentDate = moment();
        this.currentDateUTC = moment().utc();
    },
    isActive: function (routeName) {
        const route = useRoute();
        return route.name === routeName;
    },
    toggleMenu: function () {
      this.menuIsOpen = !this.menuIsOpen;
    },
    showStatusConfirm: function (status, direction) {
      this.statusConfirmData = { status, direction };
      this.statusConfirmModal = true;
    },
    confirmStatusChange: function () {
      this.toggleStatus(this.statusConfirmData.status, this.statusConfirmData.direction);
      this.statusConfirmModal = false;
      this.statusConfirmData = { status: null, direction: null };
    },
    getStatusConfirmTitle: function () {
      if (!this.trader()) return '';
      const direction = this.statusConfirmData.direction === Direction.PAY_IN ? 'in' : 'out';
      const action = this.statusConfirmData.status ? 'enable' : 'disable';
      return `${this.trans(`traders.confirm.${action}_pay_${direction}`)}?`;
    },
    navItemClass: function (item) {
      if (item.type === 'item') {
        return '';
      }
      for (let index in item.items) {
        if (item.items[index].route === this.$route.name) {
          return 'menu-open';
        }
      }
      return '';
    },
    hasBadge: function (item) {
      switch (item.route) {
        case 'antiFraudAlerts':
          return this.$store.getters['getAfHasNew']
        default:
          return false;
      }
    },
    filterMenuItems: function (items) {
      return items.filter(item => this.hasAccess(item));
    },
    doLogout: function () {
      this.$store.dispatch('logout');
      this.$router.push('login')
    },
    toggleStatus: function (isActive, direction) {
      this.$store.dispatch('toggleTraderStatus', {
        isActive,
        direction
      });
    },
    hasAccess(item) {
      return true;
    },
    trans(key, params) {
      return helper.trans(key, params)
    }
  },
  mounted() {
    setInterval(this.getDate, 1000);
    this.checkAfCount()

  },
};
</script>
